module.exports = __webpack_public_path__ + "img/uploadFile.202f7448.jpg";